import { CSSProperties, useEffect, useRef, useState } from 'react'
import type { GifsResult } from '@giphy/js-fetch-api'
import { Grid } from '@giphy/react-components'
import './style.css'
import { useAuth } from '../../global-components/src'
import { api } from '../../services/api'

interface Props {
  onSelect: (gif: any) => void
  onClose?: () => void
  style?: CSSProperties
}

export default function GifModal({ onSelect, onClose, style }: Props) {
  const { token } = useAuth();
  const [search, setSearch] = useState('');
  const [width, setWidth] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!contentRef.current) return

    const observer = new ResizeObserver(entries => {
      const entry = entries[0]
      if (entry?.contentRect.width) {
        setWidth(Math.floor(entry.contentRect.width))
      }
    })

    observer.observe(contentRef.current)

    return () => observer.disconnect()
  }, [])
 
  return (
    <div className="gif-modal" style={style}>
      {/* Header */}
      <div className="gif-header">
        <input
          className="form-control"
          type="text"
          placeholder="Pesquisar GIF - Powered by GIPHY"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Grid container */}
      <div className="gif-content new-scoll" ref={contentRef}>
        {width > 0 && (
          <Grid
            key={search}
            width={width}
            columns={window.innerWidth <=850 ? 3 : 4}
            gutter={6}
            fetchGifs={async (offset): Promise<GifsResult> => {
              // A chave do Giphy fica no backend; o front só chama o proxy
              const { data } = await api(token || undefined).get<GifsResult>(
                search ? '/giphy/search' : '/giphy/trending',
                { params: { q: search || undefined, offset } }
              )
              return data
            }}
            onGifClick={(gif, e) => {
              e.preventDefault()
              onSelect(gif)
            }}
          />
        )}
      </div>
    </div>
  )
}
